// import Configs from '@/configs'
import { parsedContent } from '@/lib/utils'

import dropSvg from '~/public/images/box-storage/drop.svg'
import enjoySvg from '~/public/images/box-storage/enjoy.svg'
import insuranceSvg from '~/public/images/box-storage/insurance.svg'
import paySvg from '~/public/images/box-storage/pay.svg'
import pickSvg from '~/public/images/box-storage/pick.svg'
import storeSvg from '~/public/images/box-storage/store.svg'

import golfSavings from '~/public/images/golf-club-storage/savings.png'
import golfEnjoy from '~/public/images/golf-club-storage/enjoy.png'
import golfInsurance from '~/public/images/golf-club-storage/insurance.png'
import golfPay from '~/public/images/golf-club-storage/pay.png'
import golfPick from '~/public/images/golf-club-storage/pick.png'
import golfStore from '~/public/images/golf-club-storage/store.png'

import luggageEnjoy from '~/public/images/luggage-storage/enjoy.png'
import luggageInsurance from '~/public/images/luggage-storage/insurance.png'
import luggagePay from '~/public/images/luggage-storage/pay.png'
import luggagePick from '~/public/images/luggage-storage/pick.png'
import luggageStore from '~/public/images/luggage-storage/store.png'
import luggageCustomer from '~/public/images/luggage-storage/customer.png'

import luggageCentral from '~/public/images/luggage-storage/central-park.png'
import luggageManhattan from '~/public/images/luggage-storage/manhatten.png'
import luggageMuseum from '~/public/images/luggage-storage/museum.png'
import luggageBroadway from '~/public/images/luggage-storage/broadway.png'
import luggageTime from '~/public/images/luggage-storage/time-square.png'
import luggageLiberty from '~/public/images/luggage-storage/state-of-liberty.png'
import luggageBrooklyn from '~/public/images/luggage-storage/brooklyn.png'
import luggageFood from '~/public/images/luggage-storage/food-and-drink.png'
import luggageShopping from '~/public/images/luggage-storage/shopping.png'

import skiEnjoy from '~/public/images/ski-storage/enjoy.png'
import skiInsurance from '~/public/images/ski-storage/insurance.png'
import skiPay from '~/public/images/ski-storage/pay.png'
import skiPick from '~/public/images/ski-storage/pick.png'
import skiStore from '~/public/images/ski-storage/store.png'
import skiSavings from '~/public/images/ski-storage/savings.png'
import skiHighLine from '~/public/images/ski-storage/highline.png'

import snowEnjoy from '~/public/images/snowboard-storage/enjoy.png'
import snowInsurance from '~/public/images/snowboard-storage/insurance.png'
import snowPay from '~/public/images/snowboard-storage/pay.png'
import snowPick from '~/public/images/snowboard-storage/pick.png'
import snowStore from '~/public/images/snowboard-storage/store.png'
import snowSavings from '~/public/images/snowboard-storage/savings.png'

// const appName = Configs.APP_NAME

const whyLargeClasses = {
  className: 'lg-mn:items-start',
  heading: 'lg-mn:text-left mx-0 text-blue-river max-w-full',
  subheading: 'lg-mn:text-left'
}

const imgClassName = { wrClassName: 'w-[170px] h-[100px]' }
const shortImgClassName = { wrClassName: 'w-[101px] h-[101px]' }

export const WHY_USE = Object.freeze({
  boxStorage: {
    // sectionClassName: '',
    header: {
      title: parsedContent(`Store Your Box, No Need To Rent Big Space`, '')
    },
    content: {
      data: [
        {
          image: {
            src: storeSvg,
            alt: 'Store',
            wrClassName: 'w-auto h-[70px]'
          },
          heading: parsedContent('Store from 1 to as many boxes you want.', 'max-w-[260px]')
        },
        {
          image: {
            src: enjoySvg,
            alt: 'Enjoy',
            wrClassName: 'w-auto h-[70px]'
          },
          heading: parsedContent('Enjoy 6 months free storage.')
        },
        {
          image: {
            src: insuranceSvg,
            alt: 'insurance',
            wrClassName: 'w-auto h-[70px]'
          },
          heading: parsedContent('Free insurance up to $250.')
        },
        {
          image: {
            src: paySvg,
            alt: 'Pay',
            wrClassName: 'w-auto h-[70px]'
          },
          heading: parsedContent('Pay for boxes, not for space.')
        },
        {
          image: {
            src: pickSvg,
            alt: 'pick',
            wrClassName: 'w-auto h-[70px]'
          },
          heading: parsedContent('We can pick up or drop off for you.')
        },
        {
          image: {
            src: dropSvg,
            alt: 'drop',
            wrClassName: 'w-auto h-[70px]'
          },
          heading: parsedContent('We can pick up or drop off for you.')
        }
      ]
    }
  },
  golfClub: {
    // sectionClassName: '',
    header: {
      title: parsedContent(`Store Your Golf Club, No Need To Rent Big Space`, '')
    },
    content: {
      data: [
        {
          image: {
            src: golfStore,
            alt: 'Store',
            ...imgClassName
          },
          heading: parsedContent('Store from 1 to as many golf clubs you want.', 'max-w-[300px]')
        },
        {
          image: {
            src: golfEnjoy,
            alt: 'Enjoy',
            ...imgClassName
          },
          heading: parsedContent('Enjoy 6 months free storage.')
        },
        {
          image: {
            src: golfInsurance,
            alt: 'insurance',
            ...imgClassName
          },
          heading: parsedContent('Free insurance up to $250.')
        },
        {
          image: {
            src: golfPay,
            alt: 'Pay',
            ...imgClassName
          },
          heading: parsedContent('Pay for golf clubs, not for space.')
        },
        {
          image: {
            src: golfPick,
            alt: 'pick',
            ...imgClassName
          },
          heading: parsedContent('We can pick up or drop off for you.')
        },
        {
          image: {
            src: golfSavings,
            alt: 'golfSavings',
            ...imgClassName
          },
          heading: parsedContent('Up to 70% savings on shipping!')
        }
      ]
    },
    callToAction: {
      text: 'Store Golf Clubs Now'
    }
  },
  luggageStorage: {
    top: {
      // sectionClassName: '',
      header: {
        title: parsedContent(`Store Your Luggage, No Need To Rent Big Space`, '')
      },
      content: {
        descriptionWrClass: 'md-mn:gap-y-[60px]',
        data: [
          {
            image: {
              src: luggageStore,
              alt: 'Store',
              ...imgClassName
            },
            heading: parsedContent('Store from 1 to as many luggage you want.', 'max-w-[300px]')
          },
          {
            image: {
              src: luggageEnjoy,
              alt: 'Enjoy',
              ...imgClassName
            },
            heading: parsedContent('Enjoy up to 6 months free storage.', 'max-w-[220px]')
          },
          {
            image: {
              src: luggageInsurance,
              alt: 'insurance',
              ...imgClassName
            },
            heading: parsedContent('Free insurance up to $250.')
          },
          {
            image: {
              src: luggagePay,
              alt: 'Pay',
              ...imgClassName
            },
            heading: parsedContent('Pay for luggage storage, not for space.', 'max-w-[250px]')
          },
          {
            image: {
              src: luggagePick,
              alt: 'pick',
              ...imgClassName
            },
            heading: parsedContent('We can pick up, or you can drop off, at our storage.', 'max-w-[300px]')
          },
          {
            image: {
              src: luggageCustomer,
              alt: 'luggageCustomer',
              ...imgClassName
            },
            heading: parsedContent('Dedicated customer support for assistance.', 'max-w-[250px]')
          }
        ]
      },
      callToAction: {
        text: 'Store Luggage Now'
      }
    },
    bottom: {
      // sectionClassName: '',
      header: {
        title: parsedContent(`Best things to do in NYC without luggage`, ''),
        subtitle: parsedContent(
          `Exploring New York City without the burden of luggage opens up a world of possibilities. Here are some of the best activities to enjoy in NYC:`,
          'max-w-[860px]'
        )
      },
      content: {
        descriptionWrClass: 'grid-cols-1 md-mn:grid-cols-2 lg-mn:grid-cols-3 md-mn:gap-y-[60px] md-mn:gap-x-10',
        bottomContent: parsedContent(
          `
          <p class="text-center max-w-[880px] mx-auto">These are just a few of the countless activities awaiting you in the vibrant and diverse city of New York. With endless attractions and experiences, you're sure to create unforgettable memories during your visit!</p>
        `,
          ''
        ),
        data: [
          {
            className: whyLargeClasses.className,
            image: {
              src: luggageCentral,
              alt: 'Store',
              ...shortImgClassName
            },
            heading: parsedContent('Visit Central Park', whyLargeClasses.heading),
            subheading: parsedContent(
              "Take a leisurely stroll, enjoy a picnic, or rent a bike to explore Central Park. Don't miss attractions like the Central Park Zoo or boating on the lake.",
              whyLargeClasses.subheading
            )
          },
          {
            className: whyLargeClasses.className,
            image: {
              src: luggageManhattan,
              alt: 'Enjoy',
              ...shortImgClassName
            },
            heading: parsedContent('Explore Manhattan', whyLargeClasses.heading),
            subheading: parsedContent(
              'Explore different areas in Manhattan, like stylish shops in Soho, artistic Greenwich Village, and tasty food in Chinatown.',
              whyLargeClasses.subheading
            )
          },
          {
            className: whyLargeClasses.className,
            image: {
              src: luggageMuseum,
              alt: 'insurance',
              ...shortImgClassName
            },
            heading: parsedContent('Museum Hopping', whyLargeClasses.heading),
            subheading: parsedContent(
              'Visit well-known museums such as the Metropolitan Museum of Art, MoMA, and the American Museum of Natural History. These museums offer a chance to immerse yourself in art, history, and culture.',
              whyLargeClasses.subheading
            )
          },
          {
            className: whyLargeClasses.className,
            image: {
              src: luggageBroadway,
              alt: 'Pay',
              ...shortImgClassName
            },
            heading: parsedContent('See a Broadway Show', whyLargeClasses.heading),
            subheading: parsedContent(
              'Experience the magic of Broadway with a wide array of theatrical performances, from dramatic plays to spectacular musicals.',
              whyLargeClasses.subheading
            )
          },
          {
            className: whyLargeClasses.className,
            image: {
              src: luggageTime,
              alt: 'pick',
              ...shortImgClassName
            },
            heading: parsedContent('Times Square and Rockefeller Center', whyLargeClasses.heading),
            subheading: parsedContent(
              'Experience the lively vibe of Times Square and visit famous spots like Rockefeller Center. You can take a tour of NBC studios or enjoy amazing views from the Top of the Rock.',
              whyLargeClasses.subheading
            )
          },
          {
            className: whyLargeClasses.className,
            image: {
              src: luggageLiberty,
              alt: 'luggageCustomer',
              ...shortImgClassName
            },
            heading: parsedContent('Statue of Liberty and Ellis Island', whyLargeClasses.heading),
            subheading: parsedContent(
              'Take a ferry to see the Statue of Liberty and visit the immigration museum on Ellis Island.',
              whyLargeClasses.subheading
            )
          },
          {
            className: whyLargeClasses.className,
            image: {
              src: luggageBrooklyn,
              alt: 'luggageCustomer',
              ...shortImgClassName
            },
            heading: parsedContent('Walk the Brooklyn Bridge', whyLargeClasses.heading),
            subheading: parsedContent(
              'Enjoy breathtaking views of the Manhattan skyline as you stroll across the historic Brooklyn Bridge.',
              whyLargeClasses.subheading
            )
          },
          {
            className: whyLargeClasses.className,
            image: {
              src: luggageFood,
              alt: 'luggageCustomer',
              ...shortImgClassName
            },
            heading: parsedContent('Food and Drink', whyLargeClasses.heading),
            subheading: parsedContent(
              "Explore NYC's food scene by visiting markets, dining at top restaurants, or joining a food tour in lively neighborhoods.",
              whyLargeClasses.subheading
            )
          },
          {
            className: whyLargeClasses.className,
            image: {
              src: luggageShopping,
              alt: 'luggageCustomer',
              ...shortImgClassName
            },
            heading: parsedContent('Shopping', whyLargeClasses.heading),
            subheading: parsedContent(
              'From luxury boutiques on Fifth Avenue to vintage treasures in Williamsburg, NYC offers unparalleled shopping experiences for every taste.',
              whyLargeClasses.subheading
            )
          }
        ]
      },
      callToAction: {
        available: false
      }
    }
  },
  skiStorage: {
    top: {
      // sectionClassName: '',
      header: {
        title: parsedContent(`Store Your Ski, No Need To Rent Big Space`, '')
      },
      content: {
        descriptionWrClass: 'md-mn:gap-y-[60px]',
        data: [
          {
            image: {
              src: skiStore,
              alt: 'Store',
              ...imgClassName
            },
            heading: parsedContent('Store from 1 to as many ski you want.', 'max-w-[300px]')
          },
          {
            image: {
              src: skiEnjoy,
              alt: 'Enjoy',
              ...imgClassName
            },
            heading: parsedContent('Enjoy up to 6 months free storage.', 'max-w-[220px]')
          },
          {
            image: {
              src: skiInsurance,
              alt: 'insurance',
              ...imgClassName
            },
            heading: parsedContent('Free insurance up to $250.')
          },
          {
            image: {
              src: skiPay,
              alt: 'Pay',
              ...imgClassName
            },
            heading: parsedContent('Pay for ski, not for space.', 'max-w-[150px]')
          },
          {
            image: {
              src: skiPick,
              alt: 'pick',
              ...imgClassName
            },
            heading: parsedContent('We can pick up or drop off for you.', 'max-w-[250px]')
          },
          {
            image: {
              src: skiSavings,
              alt: 'savings',
              ...imgClassName
            },
            heading: parsedContent('Up to 70% savings on shipping!', 'max-w-[250px]')
          }
        ]
      },
      callToAction: {
        text: 'Store Ski Now'
      }
    },
    bottom: {
      // sectionClassName: '',
      header: {
        title: parsedContent(`Best things to do in NYC without Ski`, ''),
        subtitle: parsedContent(
          `Exploring New York City without the burden of Ski opens up a world of possibilities. Here are some of the best activities to enjoy in NYC:`,
          'max-w-[860px]'
        )
      },
      content: {
        descriptionWrClass: 'grid-cols-1 md-mn:grid-cols-2 lg-mn:grid-cols-3 md-mn:gap-y-[60px] md-mn:gap-x-10',
        bottomContent: parsedContent(
          `
          <p class="text-center max-w-[880px] mx-auto">These are just a few of the countless activities awaiting you in the vibrant and diverse city of New York. With endless attractions and experiences, you're sure to create unforgettable memories during your visit!</p>
        `,
          ''
        ),
        data: [
          {
            className: whyLargeClasses.className,
            image: {
              src: luggageCentral,
              alt: 'Store',
              ...shortImgClassName
            },
            heading: parsedContent('Visit Central Park', whyLargeClasses.heading),
            subheading: parsedContent(
              "Take a leisurely stroll, enjoy a picnic, or rent a bike to explore Central Park. Don't miss attractions like the Central Park Zoo or boating on the lake.",
              whyLargeClasses.subheading
            )
          },
          {
            className: whyLargeClasses.className,
            image: {
              src: luggageManhattan,
              alt: 'Enjoy',
              ...shortImgClassName
            },
            heading: parsedContent('Explore Manhattan', whyLargeClasses.heading),
            subheading: parsedContent(
              'Dive into the diverse neighborhoods of Manhattan, from trendy boutiques in Soho to the Bohemian charm of Greenwich Village and the culinary delights of Chinatown.',
              whyLargeClasses.subheading
            )
          },
          {
            className: whyLargeClasses.className,
            image: {
              src: luggageMuseum,
              alt: 'insurance',
              ...shortImgClassName
            },
            heading: parsedContent('Museum Hopping', whyLargeClasses.heading),
            subheading: parsedContent(
              'Immerse yourself in art, history, and culture at renowned museums like the Metropolitan Museum of Art, MoMA, or the American Museum of Natural History.',
              whyLargeClasses.subheading
            )
          },
          {
            className: whyLargeClasses.className,
            image: {
              src: luggageBroadway,
              alt: 'Pay',
              ...shortImgClassName
            },
            heading: parsedContent('See a Broadway Show', whyLargeClasses.heading),
            subheading: parsedContent(
              'Experience the magic of Broadway with a wide array of theatrical performances, from dramatic plays to spectacular musicals.',
              whyLargeClasses.subheading
            )
          },
          {
            className: whyLargeClasses.className,
            image: {
              src: luggageTime,
              alt: 'pick',
              ...shortImgClassName
            },
            heading: parsedContent('Times Square and Rockefeller Center', whyLargeClasses.heading),
            subheading: parsedContent(
              'Take in the vibrant atmosphere of Times Square and explore iconic landmarks like Rockefeller Center, where you can tour NBC studios or enjoy panoramic views from the Top of the Rock.',
              whyLargeClasses.subheading
            )
          },
          {
            className: whyLargeClasses.className,
            image: {
              src: luggageLiberty,
              alt: 'luggageCustomer',
              ...shortImgClassName
            },
            heading: parsedContent('Statue of Liberty and Ellis Island', whyLargeClasses.heading),
            subheading: parsedContent(
              'Embark on a ferry ride to admire the Statue of Liberty up close and explore the immigration museum on Ellis Island.',
              whyLargeClasses.subheading
            )
          },
          {
            className: whyLargeClasses.className,
            image: {
              src: luggageBrooklyn,
              alt: 'luggageCustomer',
              ...shortImgClassName
            },
            heading: parsedContent('Walk the Brooklyn Bridge', whyLargeClasses.heading),
            subheading: parsedContent(
              'Enjoy breathtaking views of the Manhattan skyline as you stroll across the historic Brooklyn Bridge.',
              whyLargeClasses.subheading
            )
          },
          {
            className: whyLargeClasses.className,
            image: {
              src: luggageFood,
              alt: 'luggageCustomer',
              ...shortImgClassName
            },
            heading: parsedContent('Food and Drink', whyLargeClasses.heading),
            subheading: parsedContent(
              "Indulge in NYC's culinary scene by visiting food markets like Chelsea Market, dining at world-class restaurants, or taking a food tour in vibrant neighborhoods.",
              whyLargeClasses.subheading
            )
          },
          {
            className: whyLargeClasses.className,
            image: {
              src: skiHighLine,
              alt: 'luggageCustomer',
              ...shortImgClassName
            },
            heading: parsedContent('High Line and Hudson Yards', whyLargeClasses.heading),
            subheading: parsedContent(
              'Wander along the High Line, a unique elevated park built on a former railway line, and explore the innovative architecture and art installations of Hudson Yards.',
              whyLargeClasses.subheading
            )
          }
        ]
      },
      callToAction: {
        available: false
      }
    }
  },
  snowboardStorage: {
    header: {
      title: parsedContent(`Store Your Snowboard, No Need To Rent Big Space`, '')
    },
    content: {
      descriptionWrClass: 'md-mn:gap-y-[60px]',
      data: [
        {
          image: {
            src: snowStore,
            alt: 'Store',
            ...imgClassName
          },
          heading: parsedContent('Store from 1 to as many snowboards you.', 'max-w-[300px]')
        },
        {
          image: {
            src: snowEnjoy,
            alt: 'Enjoy',
            ...imgClassName
          },
          heading: parsedContent('Enjoy up to 6 months free storage.', 'max-w-[220px]')
        },
        {
          image: {
            src: snowInsurance,
            alt: 'insurance',
            ...imgClassName
          },
          heading: parsedContent('Free insurance up to $250.')
        },
        {
          image: {
            src: snowPay,
            alt: 'Pay',
            ...imgClassName
          },
          heading: parsedContent('Pay for snowboard, not for space.', 'max-w-[200px]')
        },
        {
          image: {
            src: snowPick,
            alt: 'pick',
            ...imgClassName
          },
          heading: parsedContent('We can pick up or drop off for you.', 'max-w-[250px]')
        },
        {
          image: {
            src: snowSavings,
            alt: 'savings',
            ...imgClassName
          },
          heading: parsedContent('Up to 70% savings on shipping!', 'max-w-[250px]')
        }
      ]
    },
    callToAction: {
      text: 'Store Snowboard Now'
    }
  }
})
